// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1R8Vh","top":"styles_top__9nWJA","left":"styles_left__O1Pvo","description":"styles_description__2VL-7"};